// extracted by mini-css-extract-plugin
export default {"container":"details-subtitle_container__X1hoK","primary":"details-subtitle_primary__eW41Z","secondary":"details-subtitle_secondary__Tq6TC"};